import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shippingVolume: {
    description: 'Header for the shipping volume section in the account dropdown',
    defaultMessage: 'Shipping Volume',
    id: 'zk2FGE',
  },
  approachingLimitTitle: {
    description: 'Purchase shipment volume modal title when the seller is approaching their shipment limit',
    defaultMessage: 'You Are Approaching Your Shipment Limit',
    id: 'vJsOUQ',
  },
  atLimitTitle: {
    description: 'Purchase shipment volume modal title when the seller has reached their shipment limit',
    defaultMessage: "You've Reached Your Shipment Limit",
    id: 'I22H8n',
  },
  approachingLimitBody: {
    description: 'Purchase shipment volume modal body copy when the seller is approaching their shipment limit',
    defaultMessage:
      "You've used <b>{totalUsage}</b> of <b>{shipmentLimit}</b> shipments this shipping cycle. {percentage}% of your monthly shipment limit. Purchase additional shipments to keep shipping or upgrade your volume tier for a better rate.",
    id: '7ULNF1',
  },
  atLimitBody: {
    description: 'Purchase shipment volume modal body copy when the seller has reached their shipment limit',
    defaultMessage:
      "You've used all <b>{shipmentLimit}</b> shipments included in your plan this shipping cycle. Purchase additional shipments to keep shipping.",
    id: 'BeXFJj',
  },
  shipmentsPerMonth: {
    description: 'Label for the plan shipment allowance in the usage summary',
    defaultMessage: 'Shipments / mo: {shipmentLimit}',
    id: 'MdY8vj',
  },
  monthlyShipmentLimit: {
    description: 'Label for the monthly shipment limit progress bar',
    defaultMessage: 'Monthly Shipment Limit',
    id: 'Yfodek',
  },
  monthlyShipmentLimitTooltip: {
    description: 'Tooltip explaining what the monthly shipment limit progress bar shows',
    defaultMessage:
      'The number of shipments and mark-as-shipped orders used against your plan and any purchased top-ups this shipping cycle.',
    id: '9crhZT',
  },
  usageProgress: {
    description: 'Usage count shown next to the progress bar, e.g. "4,500 / 5,000"',
    defaultMessage: '{totalUsage} / {shipmentLimit}',
    id: 'xd97s0',
  },
  selectAmountLabel: {
    description: 'Label for the label-quantity amount select',
    defaultMessage: 'Select Amount',
    id: '0AIPu+',
  },
  amountOptionLabel: {
    description: 'Option label for a shipment-quantity tier, e.g. "100 Shipments $21.00"',
    defaultMessage: '{quantity} Shipments {price}',
    id: 'ZP1JlY',
  },
  amountExpirationHelperText: {
    description: 'Helper text below the amount select explaining when unused shipments expire',
    defaultMessage: 'Unused shipments expire at the end of the shipping cycle, {renewalDate}, and do not roll over.',
    id: 'cgiFjQ',
  },
  paymentMethodLabel: {
    description: 'Label showing which payment method is being used for the purchase',
    defaultMessage: 'Paying with {paymentMethod} (Subscription)',
    id: 'QlEtj3',
  },
  cancel: {
    description: 'Cancel button label in the purchase shipment volume modal footer',
    defaultMessage: 'Cancel',
    id: 's5q2Tb',
  },
  managePlan: {
    description: 'Manage Plan button label in the purchase shipment volume modal footer',
    defaultMessage: 'Manage Plan',
    id: '2qm9qM',
  },
  purchase: {
    description: 'Purchase button label in the purchase shipment volume modal footer, e.g. "Purchase $21.00"',
    defaultMessage: 'Purchase {price}',
    id: 'W2Z35A',
  },
  purchaseError: {
    description: 'Error message shown when purchasing shipment volume fails',
    defaultMessage: 'Something went wrong. Please try again.',
    id: 'zlJMZu',
  },
  noTiersAvailableBody: {
    description: 'Purchase shipment volume modal body copy when no top-up tiers are available to purchase',
    defaultMessage:
      "You've used <b>{totalUsage}</b> of <b>{shipmentLimit}</b> shipments included in your plan this shipping cycle, {percentage}% of your monthly shipment limit.",
    id: 'CL7Puk',
  },
  upgrade: {
    description: 'Upgrade button label in the purchase shipment volume modal',
    defaultMessage: 'Upgrade',
    id: 'D8I9YY',
  },
  upgradePlansMessage: {
    description: 'Upgrade message to get users to upgrade plan',
    defaultMessage: 'The Starter Plan has a shipping volume limit of {max}. Upgrade to keep shipping!',
    id: 'wXq6es',
  },
  upgradeVolumeMessage: {
    description: 'Upgrade message to get users to upgrade volume in order to buy ad hoc',
    defaultMessage:
      "You must have at least 200 monthly shipments selected in order to buy additional shipments. Upgrade your plan's shipment volume to keep shipping!",
    id: 'CPIJ38',
  },
  purchaseAdditionalShipmentsTitle: {
    description: 'Purchase shipment volume modal title when the seller is well below their limit',
    defaultMessage: 'Purchase Additional Shipments',
    id: 'PHuI2h',
  },
  purchaseAdditionalShipmentsBody: {
    description: 'Purchase shipment volume modal body copy when the seller is well below their limit',
    defaultMessage: 'Purchase additional shipments for this shipment cycle.',
    id: 'iC8ygn',
  },
  needMoreShipmentsTitle: {
    description: 'Title for the inline banner prompting the seller to purchase more shipment volume',
    defaultMessage: 'Need More Shipments This Month?',
    id: 'SXJham',
  },
  needMoreShipmentsBody: {
    description: 'Description for the inline banner prompting the seller to purchase more shipment volume',
    defaultMessage:
      'Upgrade your monthly shipping volume{canPurchaseAdditional, select, true { or purchase additional shipments} other {}}.',
    id: 'cEv6+H',
  },
  upgradePlan: {
    description: 'Upgrade Plan action label in the need-more-shipments banner',
    defaultMessage: 'Upgrade Plan',
    id: 'Yh6Qqg',
  },
  buyMoreShipments: {
    description: 'Buy More Shipments action label in the need-more-shipments banner',
    defaultMessage: 'Buy More Shipments',
    id: 'claEN1',
  },
  contactBillingAdministrator: {
    description: 'Message shown instead of upgrade/purchase actions to a user without permission to make plan changes',
    defaultMessage: 'Contact your billing administrator to upgrade your plan or purchase additional shipments.',
    id: 'SNnsDn',
  },
  changePaymentMethod: {
    description: 'button text to switch to change payment method form',
    defaultMessage: 'Change Payment Method',
    id: 'udBuVr',
  },
  backButton: {
    description: 'Back button label in the change payment method footer',
    defaultMessage: 'Back',
    id: '9ftYEV',
  },
  submitPaymentMethod: {
    description: 'Submit button label when adding a new payment method in the change payment method footer',
    defaultMessage: 'Submit',
    id: 'lCRnAN',
  },
});
